module.exports = __webpack_public_path__ + "img/loader.cca3db1c.gif";